import system from './modules/system';
import message from './modules/message';
import mock from './modules/mock';
import module from './modules/module';
import audit from './modules/audit';
import file from './modules/file';
import {postRequest} from './modules/httpRequest';
import custom from './modules/custom';
import resource from './modules/resource';
import sqlCreater from "./modules/sqlCreater";
import baseInfo from "./modules/baseInfo";
import baseInfoAdultEducation from "./modules/baseInfoAdultEducation";
import certificateTypeManagement from "./modules/certificateTypeManagement";
import certificationCourses from "./modules/certificationCourses";
import certificateManagement from "./modules/certificateManagement";
import examAdministration from "./modules/examAdministration";
import registrationManagement from "./modules/registrationManagement";
import stuRegistration from "./modules/stuRegistration";
import chargeManagement from "./modules/chargeManagement";
import student from "./modules/student";
import teachingManage from "./modules/teachingManage";
import teachingManageAdultEducation from "./modules/teachingManageAdultEducation";
import teachingManageSkillsTraining from "./modules/teachingManageSkillsTraining";
import courseStandard from "./modules/courseStandard";
import courseStandardAdultEducation from "./modules/courseStandardAdultEducation";
import academicWarning from "./modules/academicWarning";
import common from "./modules/common";
import commonAdultEducation from "./modules/commonAdultEducation";
import welcome from "./modules/welcome";
import scoreManage from "./modules/scoreManage";
import teachingPlanImplementation from "./modules/teachingPlanImplementation";
import teachingSiteManage from "./modules/teachingSiteManage";
import internshipManage from "./modules/internshipManage";
import outsideExam from "./modules/outsideExam";
import basicReport from "./modules/basicReport";
import electiveManage from "./modules/electiveManage";
import teachingWeekManage from "./modules/teachingWeekManage";
import textbookManage from "./modules/textbookManage";
import timetableManage from "./modules/timetableManage";
import creditIdentified from "./modules/creditIdentified";
import courseArrange from "./modules/courseArrange";
import courseAdjust from "./modules/courseAdjust";
import evaluateManage from "./modules/evaluateManage";
import certificate from "./modules/certificate";
import examManage from "./modules/examManage";
import examManageJnrd from "./modules/examManageJnrd";
import combineClass from "./modules/combineClass";
import teacherRule from "./modules/teacherRule";
import fixedArrange from "./modules/fixedArrange";
import teachingPlan from "./modules/teachingPlan";
import creditManage from "./modules/creditManage";
import competitionManage from "./modules/competitionManage";
import postPracticeManage from "./modules/postPracticeManage";
import graduateManage from "./modules/graduateManage";
import teachingManagement from "./modules/teachingManagement";
import trainingAgreement from "./modules/trainingAgreement";
import teachingPlanAdultEducation from "./modules/teachingPlanAdultEducation";
import timetableManageAdultEducation from "./modules/timetableManageAdultEducation";
import electiveManageAdultEducation from "./modules/electiveManageAdultEducation";
import combineClassAdultEducation from "./modules/combineClassAdultEducation";
import courseAdjustAdultEducation from "./modules/courseAdjustAdultEducation";
import scoreManageAdultEducation from "./modules/scoreManageAdultEducation";
import attendanceStatisticsAdultEducatrion from "./modules/attendanceStatisticsAdultEducatrion";
import skillsTraining from "./modules/skillsTraining";
import courseStandardSkillsTraining from "./modules/courseStandardSkillsTraining";
import trainingAgreementSkillsTraining from "./modules/trainingAgreementSkillsTraining";
import timetableManageSkillsTraining from "./modules/timetableManageSkillsTraining";
import teachingPlanSkillsTraining from "./modules/teachingPlanSkillsTraining";
import electiveManageSkillsTraining from "./modules/electiveManageSkillsTraining";
import combineClassSkillsTraining from "./modules/combineClassSkillsTraining";
import scoreManageSkillsTraining from "./modules/scoreManageSkillsTraining";
import workStatisticSkillsTraining from "./modules/workStatisticSkillsTraining";
import externalTeacher from "./modules/externalTeacher";
import baseInfoSkillsTraining from "./modules/baseInfoSkillsTraining";
import studentAdultEducation from "./modules/studentAdultEducation";
import summaryStatistics from "./modules/summaryStatistics";
import dataSummary from "./modules/dataSummary";
import attendanceStatisticsSkillsTraining from "./modules/attendanceStatisticsSkillsTraining";
import courseAdjustSkillsTraining from "./modules/courseAdjustSkillsTraining";
import gradesManagement from "./modules/gradesManagement";
import gradesAssess from "./modules/gradesAssess";
import adultEducation from './modules/adultEducation';
import classHourStatisticsAdultEducation from "./modules/classHourStatisticsAdultEducation";
import logManagementSkillsTraining from './modules/logManagementSkillsTraining';
import qualificationRateStatisticsSkillsTraining from './modules/qualificationRateStatisticsSkillsTraining';
import scoreRegistrationSkillsTraining from './modules/scoreRegistrationSkillsTraining';

const api = {
    attendanceStatisticsAdultEducation: attendanceStatisticsAdultEducatrion,
    attendanceStatisticsSkillsTraining: attendanceStatisticsSkillsTraining,
    summaryStatistics: summaryStatistics,
    skillsTraining: skillsTraining,
    resource: resource,
    system: system,
    message: message,
    mock: mock,
    audit: audit,
    file: file,
    module: module,
    postRequest: postRequest,
    custom: custom,
    sqlCreater: sqlCreater,
    baseInfo: baseInfo,
    baseInfoAdultEducation: baseInfoAdultEducation,
    qualificationRateStatisticsSkillsTraining: qualificationRateStatisticsSkillsTraining,
    classHourStatisticsAdultEducation: classHourStatisticsAdultEducation,
    baseInfoSkillsTraining: baseInfoSkillsTraining,
    certificateTypeManagement: certificateTypeManagement,
    certificationCourses: certificationCourses,
    certificateManagement: certificateManagement,
    examAdministration: examAdministration,
    registrationManagement: registrationManagement,
    stuRegistration: stuRegistration,
    chargeManagement: chargeManagement,
    student: student,
    studentAdultEducation: studentAdultEducation,
    teachingManage: teachingManage,
    teachingManageAdultEducation: teachingManageAdultEducation,
    teachingManageSkillsTraining: teachingManageSkillsTraining,
    courseStandard: courseStandard,
    courseStandardAdultEducation: courseStandardAdultEducation,
    courseStandardSkillsTraining: courseStandardSkillsTraining,
    academicWarning: academicWarning,
    common: common,
    commonAdultEducation: commonAdultEducation,
    welcome: welcome,
    scoreManage: scoreManage,
    scoreManageAdultEducation: scoreManageAdultEducation,
    scoreManageSkillsTraining: scoreManageSkillsTraining,
    teachingPlanImplementation: teachingPlanImplementation,
    teachingSiteManage: teachingSiteManage,
    internshipManage: internshipManage,
    outsideExam: outsideExam,
    basicReport: basicReport,
    electiveManage: electiveManage,
    teachingWeekManage: teachingWeekManage,
    textbookManage: textbookManage,
    timetableManage: timetableManage,
    timetableManageAdultEducation: timetableManageAdultEducation,
    timetableManageSkillsTraining: timetableManageSkillsTraining,
    creditIdentified: creditIdentified,
    courseArrange: courseArrange,
    courseAdjust: courseAdjust,
    courseAdjustAdultEducation: courseAdjustAdultEducation,
    courseAdjustSkillsTraining: courseAdjustSkillsTraining,
    evaluateManage: evaluateManage,
    electiveManageAdultEducation: electiveManageAdultEducation,
    electiveManageSkillsTraining: electiveManageSkillsTraining,
    certificate: certificate,
    examManage: examManage,
    examManageJnrd: examManageJnrd,
    gradesManagement: gradesManagement,
    gradesAssess: gradesAssess,
    combineClass: combineClass,
    combineClassAdultEducation: combineClassAdultEducation,
    combineClassSkillsTraining: combineClassSkillsTraining,
    teacherRule: teacherRule,
    fixedArrange: fixedArrange,
    teachingPlan: teachingPlan,
    teachingPlanAdultEducation: teachingPlanAdultEducation,
    teachingPlanSkillsTraining: teachingPlanSkillsTraining,
    creditManage: creditManage,
    competitionManage: competitionManage,
    postPracticeManage: postPracticeManage,
    graduateManage: graduateManage,
    teachingManagement: teachingManagement,
    trainingAgreement: trainingAgreement,
    trainingAgreementSkillsTraining: trainingAgreementSkillsTraining,
    workStatisticSkillsTraining: workStatisticSkillsTraining,
    dataSummary: dataSummary,
    externalTeacher: externalTeacher,
    adultEducation: adultEducation,
    logManagementSkillsTraining: logManagementSkillsTraining,
    scoreRegistrationSkillsTraining: scoreRegistrationSkillsTraining,
};
export default api;



// WEBPACK FOOTER //
// ./src/api/index.js